<template>
    <v-card class="ma-4">
        <v-toolbar>
            <v-toolbar-title>Log</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
            <div class="log-box grey lighten-2 ma-3 pa-3" ref="logBox">
                <template v-for="(logged, index) in log">
                    <log-message :key="index" :type="logged.type" :message="logged.message"/>
                </template>
            </div>
            <div class="ma-3">
                <v-progress-linear :value="payloadDownloadProgress" height="20" color="info"></v-progress-linear>
                <p class="caption">
                    Payload Download Progress
                </p>
                <v-progress-linear :value="writePayloadProgress" height="20" color="success"></v-progress-linear>
                <p class="caption">
                    Payload Write Progress
                </p>
            </div>
        </v-card-text>
        <v-card-actions>
            <v-btn flat color="white" @click.native="clearLog()">Clear</v-btn>
        </v-card-actions>
    </v-card>
</template>
<script>
import { mapState } from "vuex";
import LogMessage from "./LogMessage.vue";
import { CLEAR_LOG } from "../constants/mutation-types";

export default {
  name: "log",
  computed: {
    ...mapState(["payloadDownloadProgress", "writePayloadProgress", "log"])
  },
  methods: {
    clearLog() {
      this.$store.commit(CLEAR_LOG);
    }
  },
  updated() {
    const logBox = this.$refs.logBox;

    logBox.scrollTop = logBox.scrollHeight - logBox.clientHeight;
  },
  components: { LogMessage }
};
</script>
<style>
.log-box {
  overflow: scroll;
  height: 150px;
  border: 1px solid black;
}
</style>
